import { StyleSheet, ViewStyle, TextStyle } from 'react-native';

// Define the global styles using StyleSheet.create
const gs = StyleSheet.create({
  loader: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    flex: 1,
    elevation: 4,
    backgroundColor: 'rgba(0,0,0,0.7)',
    justifyContent: 'flex-end',
    zIndex: 4,
  } as ViewStyle,

  flexRow: {
    flexDirection: 'row',
  } as ViewStyle,

  flexWrap: {
    flexWrap: 'wrap',
  } as ViewStyle,

  spaceAround: {
    justifyContent: 'space-around',
  } as ViewStyle,

  spaceBetween: {
    justifyContent: 'space-between',
  } as ViewStyle,

  justifyStart: {
    justifyContent: 'flex-start',
  } as ViewStyle,

  justifyEnd: {
    justifyContent: 'flex-end',
  } as ViewStyle,

  justifyCenter: {
    justifyContent: 'center',
  } as ViewStyle,

  alignItemsCenter: {
    alignItems: 'center',
  } as ViewStyle,

  alignItemsStart: {
    alignItems: 'flex-start',
  } as ViewStyle,

  alignItemsEnd: {
    alignItems: 'flex-end',
  } as ViewStyle,

  alignItemsBaseline: {
    alignItems: 'baseline',
  } as ViewStyle,

  textCenter: {
    textAlign: 'center',
  } as TextStyle,

  textLeft: {
    textAlign: 'left',
  } as TextStyle,

  textRight: {
    textAlign: 'right',
  } as TextStyle,

  // Functions with parameters, typed
  setTextColor: ((color: string) => ({ color })) as TextStyle,

  setBottomBorder: ((width: number, color: string = '') => ({
    borderBottomWidth: width,
    borderBottomColor: color,
  })) as ViewStyle,

  setTopBorder: ((width: number, color: string = '') => ({
    borderTopWidth: width,
    borderTopColor: color,
  })) as ViewStyle,

  setVerticalBorder: ((width: number, color: string = '') => ({
    borderBottomWidth: width,
    borderBottomColor: color,
    borderTopWidth: width,
    borderTopColor: color,
  })) as ViewStyle,

  setMarginTop: ((val: number) => ({
    marginTop: val,
  })) as ViewStyle,

  setMarginBottom: ((val: number) => ({
    marginBottom: val,
  })) as ViewStyle,

  setMarginLeft: ((val: number) => ({
    marginLeft: val,
  })) as ViewStyle,

  setMarginRight: ((val: number) => ({
    marginRight: val,
  })) as ViewStyle,

  setMarginVertical: ((val: number) => ({
    marginVertical: val,
  })) as ViewStyle,

  setMarginHorizontal: ((val: number) => ({
    marginHorizontal: val,
  })) as ViewStyle,

  setMargin: ((val: number) => ({
    margin: val,
  })) as ViewStyle,

  setPadding: ((val: number) => ({
    padding: val,
  })) as ViewStyle,

  setPaddingHorizontal: ((val: number) => ({
    paddingHorizontal: val,
  })) as ViewStyle,

  setPaddingVertical: ((val: number) => ({
    paddingVertical: val,
  })) as ViewStyle,

  setPaddingBottom: ((val: number) => ({
    paddingBottom: val,
  })) as ViewStyle,

  setPaddingTop: ((val: number) => ({
    paddingTop: val,
  })) as ViewStyle,

  setPaddingRight: ((val: number) => ({
    paddingRight: val,
  })) as ViewStyle,

  setWidth: ((val: number | string) => ({
    width: val,
  })) as ViewStyle,

  setHeight: ((val: number | string) => ({
    height: val,
  })) as ViewStyle,

  setBorderRadius: ((val: number) => ({
    borderRadius: val,
  })) as ViewStyle,

  flexOne: {
    flex: 1,
  } as ViewStyle,

  flexTwo: {
    flex: 2,
  } as ViewStyle,

  setFlex: ((val: number) => ({
    flex: val,
  })) as ViewStyle,

  setBg: ((val: string) => ({
    backgroundColor: val,
  })) as ViewStyle,

  setColor: ((val: string) => ({
    color: val,
  })) as ViewStyle,

  strikeOut: {
    textDecorationLine: 'line-through',
    textDecorationStyle: 'solid',
  } as TextStyle,

  textAlignCenter: {
    textAlign: 'center',
  } as TextStyle,

  apiModalErrorsCommon: {
    marginBottom: 48,
  } as ViewStyle,

  positionRelative: {
    position: 'relative',
  } as ViewStyle,

  positionCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  } as ViewStyle,

  shadowEffect: {
    shadowColor: '#343434',
    shadowOpacity: 0.8,
    elevation: 16,
    borderWidth: 0,
    shadowRadius: 15,
    shadowOffset: { width: 1, height: 5 },
  } as ViewStyle,
});

export default gs;
